<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  page: {
    type: Number,
    required: true,
  },
  size: {
    type: Number,
    required: true,
  },
  pages: {
    type: Number,
    required: true,
  },
  total: {
    type: Number,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
})

const previous = ref([])
const current = ref([])
const next = ref([])

current.value = props.items.slice(0, props.page * props.size)

next.value = getNext(props.items, props.page)

function getNext(items, page) {
  const data = items.slice(
    page * props.size,
    Math.min(page * props.size + 3, props.total),
  )
  return data
}

function loadNext(page) {
  const data = props.items.slice(
    (page - 1) * props.size,
    Math.min(page * props.size, props.total),
  )

  current.value = current.value.concat(data)
}
</script>

<template>
  <LoadMore
    :name="name"
    :page="page"
    :size="size"
    :pages="pages"
    :total="total"
    @next="loadNext"
  >
    <template #previous>
      <div class="grid">
        <SlideStory
          v-for="(item, index) in previous"
          :key="index"
          :slide="item"
          class="item"
        />
      </div>
    </template>
    <template #default>
      <div
        class="grid"
        :class="{
          'grid--previous': previous.length > 0,
          'grid--next': next.length > 0,
        }"
      >
        <SlideStory
          v-for="(item, index) in current"
          :key="index"
          :slide="item"
          class="item"
        />
      </div>
    </template>
    <template #next>
      <div class="grid">
        <SlideStory
          v-for="(item, index) in next"
          :key="index"
          :slide="item"
          class="item"
        />
      </div>
    </template>
  </LoadMore>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 40px;
  row-gap: clamp(20px, 1.39vw + 15.56px, 40px);
  margin: 0;

  @include media-breakpoint-down(640) {
    grid-template-columns: 1fr;
  }

  &--previous {
    margin-top: 30px;
  }

  &--next {
    margin-bottom: 30px;
  }
}

.item {
  height: clamp(425px, 16.32vw + 372.78px, 660px);
  width: 100%;
}
</style>
